module.exports = __webpack_public_path__ + "static/media/RKP_Back.88dee009.jpg";